import { toast } from "react-toastify";
import { axios } from "../../utils/axios";
import { toastOptions } from "../../config/toast";

export const getListadoDeActasVencidas = async (setListadoDeActasVencidas, setIsLoading) => {
  setIsLoading(true);
  const result = await axios().get("listado_de_actas_vencidas");
  const { data, error } = result.data;

  if (data) {
    setListadoDeActasVencidas(data);
  }

  if (error) {
    toast.error(error, toastOptions);
  }
  setIsLoading(false);
};

export const getListadoExcel = async () => {
  const result = await axios().get("excel_listado_de_actas_vencidas", {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([result.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `Listado de Actas Vencidas - ${new Date().toLocaleDateString()}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

export const listadoDeActasVencidasTableData = (data) => {
  const columns = [
    { field: "id", headerName: "# id", hide: true },
    {
      field: "created_at",
      headerName: "Fecha de Carga",
      flex: 1,
      renderCell: (params) => {
        const date = new Date(params.row.created_at);
        return <p className='mb-0'>{date.toLocaleDateString()}</p>;
      },
    },
    { field: "acta", headerName: "Acta", flex: 1 },
    { field: "patente", headerName: "Patente", flex: 1 },
    { field: "dni_multado", headerName: "Dni Multado", flex: 1 },
    { field: "correo_multado", headerName: "Correo Multado", flex: 1 },
  ];

  const rows = data.map((d, index) => {
    return {
      id: d.id,
      created_at: d.created_at,
      acta: d.dependencia + "-" + d.numero_acta,
      patente: d.patente,
      dni_multado: d.dni_multado ?? "Sin dni",
      correo_multado: d.correo_multado ?? "Sin correo",
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return String(d.acta)?.toString().toLowerCase().includes(value) || String(d.patente)?.toLowerCase().includes(value) || String(d.dni_multado)?.toLowerCase().includes(value) || String(d.correo_multado)?.toLowerCase().includes(value);
  };

  return { columns, rows, filter };
};
